import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { NetworkQuestionsEnablementMode } from '@ms/yammer-graphql';
import { Reducer } from 'redux';

import {
  FeatureAccessSettingsClientLoadFulfilledAction,
  FeatureAccessSettingsClientLoadPendingAction,
  FeatureAccessSettingsClientLoadRejectedAction,
  FeatureAccessSettingsUpdateForAudienceAction,
} from '../../domains/featureAccessSettings/actions.types';
import { EditNetworkQuestionSettingsFulfilledAction } from '../../domains/featureAccessSettings/editNetworkQuestionSettingsActions.types';

import { FeatureAccessSettingsLifecycle } from './types';

export type FeatureAccessSettingsAction =
  | FeatureAccessSettingsClientLoadPendingAction
  | FeatureAccessSettingsClientLoadRejectedAction
  | FeatureAccessSettingsClientLoadFulfilledAction
  | EditNetworkQuestionSettingsFulfilledAction
  | FeatureAccessSettingsUpdateForAudienceAction;

const initialState: FeatureAccessSettingsLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const setNetworkQuestionsEnablementMode = (
  state: FeatureAccessSettingsLifecycle,
  networkQuestionsEnablementMode: NetworkQuestionsEnablementMode
) =>
  state.fulfilled
    ? {
        ...state,
        fulfilled: {
          ...state.fulfilled,
          networkQuestionsEnablementMode,
        },
      }
    : state;

const updateFeatureAccessSettingsForAudience = (
  state: FeatureAccessSettingsLifecycle,
  payload: FeatureAccessSettingsUpdateForAudienceAction['payload']
) => {
  if (!state.fulfilled) {
    return state;
  }

  return {
    ...state,
    fulfilled: { ...state.fulfilled, ...payload },
  };
};

const reducer: Reducer<FeatureAccessSettingsLifecycle, FeatureAccessSettingsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'FEATURE_ACCESS_SETTINGS.LOAD_PENDING':
      return setPending();
    case 'FEATURE_ACCESS_SETTINGS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'FEATURE_ACCESS_SETTINGS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    case 'NETWORK_QUESTION_SETTINGS.EDIT_FULFILLED':
      return setNetworkQuestionsEnablementMode(state, action.networkQuestionsMode);
    case 'FEATURE_ACCESS_SETTINGS.UPDATE_HAS_NETWORK_WIDE_AUDIENCE':
      return updateFeatureAccessSettingsForAudience(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
